export const orderConstants = {
	OrderGetByFilterRequest:"ORDER_GET_BYFILTER_STARTED",
	OrderGetByFilterSuccess: "ORDER_GET_BYFILTER_COMPLETED",
	OrderGetByFilterFailure: "ORDER_GET_BYFILTER_FAILED",

	OrderRecurringGetByFilterRequest : "ORDER_RECURRING_GET_BYFILTER_STARTED",
	OrderRecurringGetByFilterSuccess : "ORDER_RECURRING_GET_BYFILTER_COMPLETED",
	OrderRecurringGetByFilterFailure : "ORDER_RECURRING_GET_BYFILTER_FAILED",
}